export default "__VITE_ASSET__WZXcLNKV__"